import { httpRequest } from "@services/http";
import type { LaunchDashboardFilterOptions } from "../models/dashboard";
import { legacyDashboardUrl } from "./legacyDashboardUrl";

export class CommandGetLaunchDashboardFilters {
    async run(): Promise<LaunchDashboardFilterOptions> {
        return await httpRequest<LaunchDashboardFilterOptions>(
            legacyDashboardUrl("reporting/launch-dashboard-filters/").toString(),
        );
    }
}
